// src/store.ts
// Auth + notifications; server state is in TanStack Query (see services/queries.ts)
import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/auth";
import notificationsReducer from "./slices/notificationsSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    notifications: notificationsReducer,
  },
});

// Types for use throughout the app
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
